module.exports = __webpack_public_path__ + "img/cogvis_green.33e3f31d.png";